import React, { useMemo } from 'react';
import styles from './styles.less';

type ModeType = 'graph' | 'hybrid' | 'kepler';

interface Mode {
    id: ModeType;
    name: string;
}

interface KeplerDropdownProps {
    enabled?: boolean;
    mode?: ModeType;
    dropdownVisible?: boolean;
    hasKeplerEncodings?: boolean;
    onSelectMode: (mode: ModeType) => void;
    onToggleDropdown: () => void;
}

export const KeplerDropdownComponent: React.FC<KeplerDropdownProps> = ({
    enabled = false,
    mode = 'graph',
    dropdownVisible = false,
    hasKeplerEncodings = false,
    onSelectMode,
    onToggleDropdown
}) => {

    if (!enabled) {
        return null;
    }

    const modes: Mode[] = [
        { id: 'graph',  name: 'Graph' },
        { id: 'hybrid', name: 'Graph + Map' },
        { id: 'kepler', name: 'Map' }
    ];

    const handleModeSelect = (modeId: ModeType) => {
        onSelectMode(modeId);
        onToggleDropdown();
    };

    const anchorPosition = useMemo(() => {
        const el = document.getElementById('toggle-kepler-dropdown');
        if (el && el.getBoundingClientRect) {
            const rect = el.getBoundingClientRect();
            return { left: rect.left, top: rect.top };
        }
        return { left: 245, top: 20 };
    }, [dropdownVisible]);

    return (
        <div className={styles['kepler-dropdown-wrapper']}>
            {dropdownVisible && (
                <div
                    className={styles['kepler-dropdown-content']}
                    style={{ left: anchorPosition.left, top: anchorPosition.top }}
                    onMouseLeave={onToggleDropdown}
                >
                    <div className={styles['modes-container']}>
                        {modes.map((m) => {
                            const isDisabled = !hasKeplerEncodings && m.id !== 'graph';
                            return (
                                <button
                                    key={m.id}
                                    className={`${styles['mode-row']} ${isDisabled ? styles['mode-row-disabled'] : ''}`}
                                    onClick={() => handleModeSelect(m.id)}
                                    aria-pressed={mode === m.id}
                                    disabled={isDisabled}
                                >
                                    <i className={`${styles['mode-icon']} ${
                                        m.id === 'graph' ? 'fa fa-share-alt' : m.id === 'hybrid' ? 'fa fa-sitemap' : 'fa fa-map'
                                    }`} />
                                    <span className={`${styles['mode-text']}`}>{m.name}</span>
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default KeplerDropdownComponent;
